import { Link } from 'react-router';
import { CustomerTravelplansResponse } from '~/types/api';
import reservationsStyles from '~/styles/myEnvironment/reservations.module.css';
import formatDate from '~/helpers/formatDate';
import useTranslation from '~/hooks/useTranslation';
import IconCalendar from '~icons/tabler/calendar';
import IconUsers from '~icons/tabler/users';
import IconUser from '~icons/tabler/user';

type Props = {
  reservations: CustomerTravelplansResponse['data'];
};

export default function ReservationsList({ reservations }: Props) {
  const translate = useTranslation();

  return (
    <ul className={reservationsStyles.reservationsList}>
      {reservations.map((reservation) => (
        <li key={reservation.id}>
          <Link
            to={`/reservations/${reservation.id}`}
            className={reservationsStyles.reservationItem}
          >
            <h3 className={reservationsStyles.reservationTitle}>
              {`${reservation.id} - `}
              {reservation.name}
            </h3>

            <div className={reservationsStyles.reservationMeta}>
              {reservation.start_date && reservation.end_date && (
                <time
                  className={reservationsStyles.reservationDate}
                  dateTime={reservation.start_date}
                >
                  <IconCalendar />
                  {formatDate(reservation.start_date)}
                  {' – '}
                  {formatDate(reservation.end_date)}
                </time>
              )}

              <div className={reservationsStyles.reservationPax}>
                {reservation.pax > 1 ? <IconUsers /> : <IconUser />}
                {
                  reservation.pax > 1
                    ? `${reservation.pax} ${translate('myEnvironment.reservations.persons')}`
                    : `${reservation.pax} ${translate('myEnvironment.reservations.person')}`
                }
              </div>
            </div>
          </Link>
        </li>
      ))}
    </ul>
  );
}
